module.exports = __webpack_public_path__ + "img/runpay.3f92639b.png";